import React from 'react';

const DOM_Intro = () => {
  return (
    <div >
      <h1>DOM_Intro</h1>
      <p>Placeholder component for: "DOM Intro"</p>
    </div>
  );
};

export default DOM_Intro;
